import './css/all.css';
import './http-interceptor';
import { hydrate, render } from 'cdui-js';
import { bootstrapI18n } from './i18n';
import { App } from './pages/App';

const mount = async () => {
  // 只拉当前语言包；开户/加开户已静态并入 App 主图
  await bootstrapI18n();
  const body = document.body;

  // 服务端渲染
  if ((window as any)._$HY) {
    let icons = document.getElementById('ICONS');

    // 激活客户端组件
    hydrate(() => <App />, body);
    body.insertBefore(icons, body.firstChild);
  } else {
    // 客户端渲染
    render(App, body);
  }
};

void mount();
